// Auto-generated index file for locale exports
import en from './en'
import fr from './fr'
import hu from './hu'
import it from './it'
import ro from './ro'

const locales = {
  en: en,
  fr: fr,
  hu: hu,
  it: it,
  ro: ro
}

export default locales
